const NEWS_JSON_PATH = '/shoji/assets/data/news.json';
const TOP_LIMIT = 3;
const LIST_LIMIT = 20;

/**
 * ニュースアイテムのHTML文字列を生成
 * @param {Object} item
 * @param {string} prefix - CSSクラスのプレフィックス ('l-topNews' or 'l-news')
 * @returns {string}
 */
function createNewsItemHTML(item, prefix) {
	const target = item.target ? ` target="${item.target}"` : '';
	return `<a class="${prefix}__listItem" href="${item.url}"${target}>
				<span class="${prefix}__listItem__date">${item.date}</span>
				<span class="${prefix}__listItem__category">${item.category}</span>
				<p class="${prefix}__listItem__title">${item.title}</p>
			</a>`;
}

/**
 * ページネーションのHTML文字列を生成
 * @param {number} currentPage
 * @param {number} totalPages
 * @returns {string}
 */
function createPagerHTML(currentPage, totalPages) {
	if (totalPages <= 1) return '';

	let html = '<div class="c-pager">';

	// 前へ
	if (currentPage > 1) {
		html += `<a class="c-pager__prev" href="?page=${currentPage - 1}"></a>`;
	} else {
		html += `<span class="c-pager__prev is-disabled"></span>`;
	}

	// ページ番号
	const range = 2;
	for (let i = 1; i <= totalPages; i++) {
		if (
			i === 1 ||
			i === totalPages ||
			(i >= currentPage - range && i <= currentPage + range)
		) {
			const isCurrent = i === currentPage ? ' is-current' : '';
			html += `<a class="c-pager__link${isCurrent}" href="?page=${i}">${i}</a>`;
		} else if (
			i === currentPage - range - 1 ||
			i === currentPage + range + 1
		) {
			html += `<span class="c-pager__ellipsis">...</span>`;
		}
	}

	// 次へ
	if (currentPage < totalPages) {
		html += `<a class="c-pager__next" href="?page=${currentPage + 1}"></a>`;
	} else {
		html += `<span class="c-pager__next is-disabled"></span>`;
	}

	html += '</div>';
	return html;
}

/**
 * トップページのニュースリストを描画（最大3件）
 */
function initTopNews() {
	const listEl = document.querySelector('.l-topNews__list');
	if (!listEl) return;

	fetch(NEWS_JSON_PATH)
		.then(res => res.json())
		.then(data => {
			const items = data.slice(0, TOP_LIMIT);
			listEl.innerHTML = items.map(item => createNewsItemHTML(item, 'l-topNews')).join('');
		})
		.catch(err => console.error('News fetch error:', err));
}

/**
 * ニュース一覧ページのリストとページネーションを描画（20件/ページ）
 */
function initNewsList() {
	const listEl = document.querySelector('.l-news__list');
	const pagerEl = document.querySelector('.c-pager');
	if (!listEl) return;

	const params = new URLSearchParams(window.location.search);
	const currentPage = Math.max(1, parseInt(params.get('page') || '1', 10));

	fetch(NEWS_JSON_PATH)
		.then(res => res.json())
		.then(data => {
			const totalPages = Math.ceil(data.length / LIST_LIMIT);
			const page = Math.min(currentPage, totalPages || 1);
			const start = (page - 1) * LIST_LIMIT;
			const items = data.slice(start, start + LIST_LIMIT);

			listEl.innerHTML = items.map(item => createNewsItemHTML(item, 'l-news')).join('');

			const pagerHTML = createPagerHTML(page, totalPages);
			if (pagerEl) {
				pagerEl.outerHTML = pagerHTML;
			} else {
				listEl.insertAdjacentHTML('afterend', pagerHTML);
			}
		})
		.catch(err => console.error('News fetch error:', err));
}

export { initTopNews, initNewsList };
